"use client";
import * as React from "react";
import { LuCalendar } from "react-icons/lu";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { DEFAULT_POST_COMMENT_FORMAT, FocusDateParser } from "@/utils/date";
import { cn } from "@/utils/lib";
type DatePickerProps = {
  date?: Date;
  label?: string;
  setDate?: (date?: Date) => void;
  buttonClassName?: string;
};
export function DatePicker({
  date = FocusDateParser.now(),
  setDate,
  label = "Pick a date",
  buttonClassName = "w-[280px]",
}: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button
            variant="outline"
            className={cn(
              "justify-start text-left font-normal",
              !date && "text-muted-foreground",
              buttonClassName,
            )}
          >
            <LuCalendar className="mr-2 size-4" />
            {date ? (
              FocusDateParser.formatUTCDate(date, DEFAULT_POST_COMMENT_FORMAT)
            ) : (
              <span>{label}</span>
            )}
          </Button>
        }
      />
      <PopoverContent className="flex w-auto flex-col space-y-2 p-2">
        <div className="rounded-md">
          <Calendar mode="single" selected={date} onSelect={setDate} />
        </div>
      </PopoverContent>
    </Popover>
  );
}
